import { API_PRIVATE_HOST, API_PUBLIC_HOST } from "@/_constant/urlconstants";
import axios from "axios";
import api from "./request";

export async function fetchBankDetails(token, userId) {
  const resp = await api.get(`${API_PRIVATE_HOST}/bank-details/${userId}`);
  if (resp.status !== 200) {
    throw Error("Failed to fetch bank details");
  }
  return await resp.data;
}

export async function saveBankDetails(token, data) {
  const resp = await api.post(`${API_PRIVATE_HOST}/bank-details`, data)

  if (resp.status !== 200 && !resp.data.success) {
    throw Error("Failed to save bank details")
  }
  return await resp.data;
}

export async function updateBankDetails(token, bankId, data) {
  const resp = await axios({
    method: 'put',
    url: `${API_PRIVATE_HOST}/bank-details/${bankId}`,
    data: data,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token,
    }
  })

  if (resp.status !== 200 && !resp.data.success) {
    throw Error("Failed to save bank details")
  }
  return await resp.data;
}

export async function previewOrDownloadCoordinatorInvoice(token, invoiceDate, isPreview = true) {
  const resp = await axios.get(`${API_PRIVATE_HOST}/referrals/commission/agent/invoice?invoice-date=${invoiceDate}&invoice-medium=${isPreview}`,
    {
      "headers": { "Authorization": token },
      "responseType": 'arraybuffer'
    })

    if (resp.status !== 200) {
      throw Error("Failed to get coordinator invoice")
    }

    return await resp.data;
}

export async function addOrUpdateReferralDiscount(payload) {
  return api.put(`${API_PRIVATE_HOST}/referrals/discount-coupons`, payload);
}

export function fetchReferralOnboardingCount() {
  return api.get(`${API_PRIVATE_HOST}/referrals/agent/onboarding/count`);
}